import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker/es';
import SubmitButton from '../_shared/SubmitButton';
import moment from 'moment';

class MemberReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterText: 'Overall',
            report: this.props.report,
            jobTypes: this.props.jobTypes,
            dateFrom: new Date(this.props.dateFrom),
            dateTo: new Date(this.props.dateTo),
        };
    }

    handleChange = (e, name) => {
        this.setState({
            [name]: e,
        });
    };

    formatMinutes = (time) => {
        return time > 0 ? Math.floor(time / 60) + 'h ' + (time % 60) + 'm' : '0';
    };

    getJobs = (date_from, date_to) => {
        $.ajax({
            url: this.props.url,
            data: { date_from: date_from, date_to: date_to },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    report: data.report,
                });
            },

            error: (xhr, status, err, data) => {
                console.log(this.props, status, err.toString());
            },
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        let date_from = moment(this.state.dateFrom).isValid() ? moment(this.state.dateFrom).format('YYYY/MM/DD') : '';
        let date_to = moment(this.state.dateTo).isValid() ? moment(this.state.dateTo).format('YYYY/MM/DD') : '';
        let filterText = '';

        if (date_from && date_to) {
            filterText = 'From ' + date_from + ' to ' + date_to;
        } else if (date_from && !date_to) {
            filterText = 'From ' + date_from + ' to ' + moment().format('YYYY/MM/DD');
        } else if (!date_from && date_to) {
            filterText = 'All jobs up to ' + date_to;
        } else {
            filterText = 'Overall';
        }

        this.getJobs(date_from, date_to);

        this.setState({
            filterText: filterText,
        });
    };

    render() {
        let reports = this.state.report;
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <DatePicker
                                className="form-control"
                                name="date-from"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Date from"
                                selected={this.state.dateFrom}
                                onChange={(date) => this.handleChange(date, 'dateFrom')}
                                isClearable
                            />
                        </div>
                        <div className="col-md-4 form-group">
                            <DatePicker
                                className="form-control"
                                name="date_to"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Date to"
                                selected={this.state.dateTo}
                                onChange={(date) => this.handleChange(date, 'dateTo')}
                                isClearable
                            />
                        </div>
                        <div className="col-md-4 form-group">
                            <SubmitButton buttonText="Filter" className="form-control" />
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">{this.state.filterText}</h4>

                        <table className="table transform-text">
                            <thead>
                                <tr>
                                    <th>For</th>
                                    <th>Profit and loss</th>
                                    <th>Time spent working single person jobs</th>
                                    <th>Time spent working two person jobs</th>
                                    <th>Travel time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.jobTypes.map((jobType) => {
                                    let report = this.state.report[jobType.name];

                                    return (
                                        <tr key={jobType.id}>
                                            <td>{jobType.name}</td>
                                            <td>{report.price}</td>
                                            <td>{this.formatMinutes(report.working_time_single)}</td>
                                            <td>{this.formatMinutes(report.working_time_two_person)}</td>
                                            <td>{this.formatMinutes(report.travel_time)}</td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td>Waste collection</td>
                                    <td>{reports['Volume Jobs'].price}</td>
                                    <td>{this.formatMinutes(reports['Volume Jobs'].working_time_single)}</td>
                                    <td>{this.formatMinutes(reports['Volume Jobs'].working_time_two_person)}</td>
                                    <td>{this.formatMinutes(reports['Volume Jobs'].travel_time)}</td>
                                </tr>
                                <tr>
                                    <td>Overall</td>
                                    <td>{reports.total_price}</td>
                                    <td>{this.formatMinutes(reports.total_working_minutes_single)}</td>
                                    <td>{this.formatMinutes(reports.total_working_minutes_two_person)}</td>
                                    <td>{this.formatMinutes(reports.total_travel_time)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        );
    }
}

if (document.getElementById('member-reports')) {
    let element = document.getElementById('member-reports');

    ReactDOM.render(
        <MemberReports
            report={JSON.parse(element.dataset.report)}
            jobTypes={JSON.parse(element.dataset.job_types)}
            url={JSON.parse(element.dataset.url)}
            dateFrom={element.dataset.date_from}
            dateTo={element.dataset.date_to}
        />,
        element
    );
}
export default MemberReports;
